import { get } from './utils';

/**
 * Get dashboard statistics
 * @param {Object} filters - Filter options (dateFrom, dateTo, companyId, industryId, workingTypeId)
 * @returns {Promise} Dashboard statistics
 */
export async function getDashboardStats(filters = {}) {
  return get('/dashboard/stats', filters);
}

/**
 * Get company statistics with job and application counts
 * @param {Object} filters - Filter options
 * @returns {Promise} Company statistics
 */
export async function getCompanyStats(filters = {}) {
  return get('/dashboard/companies', filters);
}

/**
 * Get candidate statistics
 * @param {Object} filters - Filter options
 * @returns {Promise} Candidate statistics
 */
export async function getCandidateStats(filters = {}) {
  return get('/dashboard/candidates', filters);
}

/**
 * Get position/recruitment statistics
 * @param {Object} filters - Filter options
 * @returns {Promise} Position statistics
 */
export async function getPositionStats(filters = {}) {
  return get('/dashboard/positions', filters);
}

/**
 * Get company detail with jobs and applications
 * @param {number} companyId - Company ID
 * @param {Object} filters - Filter options
 * @returns {Promise} Company detail with jobs and applications
 */
export async function getCompanyDetail(companyId, filters = {}) {
  return get(`/dashboard/companies/${companyId}`, filters);
}
